import ErrorConstants from 'utils/ErrorConstants';

const PAY_5545_FALLBACK_ERROR_CODE = -1;

function isKlarnaFallbackAuthFailure(errorData) {
    return errorData?.key === ErrorConstants.ERROR_CODES.KLARNA_NOT_AUTHORIZED
        && errorData?.errorCode === PAY_5545_FALLBACK_ERROR_CODE;
}

export { isKlarnaFallbackAuthFailure };
